import {
    SET_PAYEVER,
    SET_PENDING_ORDER,
	RESET_PAYEVER,
    FAILED_PAYEVER,
    SUCCESS_PAYEVER,
    PENDING_PAYEVER,
    CANCEL_PAYEVER,
    CHECK_PAYEVER,
    RESTART_PAYEVER,
    UNKNOWN_ERROR_PAYEVER,
    UNCHECK_PAYEVER,
    CHECKOUT_PAYEVER
} from '../constants';



export function restartPayever(obj) {
    return {
        type: RESTART_PAYEVER,
        payload: obj
    }
}
export function setPayever(obj) {
    return {
        type: SET_PAYEVER,
        payload: obj
    }
}
export function checkoutPayever(obj) {
    return {
        type: CHECKOUT_PAYEVER,
        payload: {}
    }
}
export function setPendingOrder(obj) {
    return {
        type: SET_PENDING_ORDER,
        payload: obj
    }
}

export function successPayever(obj) {
    return {
        type: SUCCESS_PAYEVER,
        payload: obj
    }
}

export function pendingPayever(obj) {
    return {
        type: PENDING_PAYEVER,
        payload: obj
    }
}

export function cancelPayever() {
    return {
        type: CANCEL_PAYEVER,
        payload: {}
    }
}

export function failedPayever() {
    return {
        type: FAILED_PAYEVER,
        payload: {}
    }
}

export function unknownErrorPayever() {
    return {
        type: UNKNOWN_ERROR_PAYEVER,
        payload: {}
    }
}

export function resetPayever() {
    return {
        type: RESET_PAYEVER,
        payload: {}
    }
}

export function checkPayever() {
    return {
        type: CHECK_PAYEVER,
        payload: {}
    }
}

export function uncheckPayever() {
    return {
        type: UNCHECK_PAYEVER,
        payload: {}
    }
}



// WEBPACK FOOTER //
// ./src/actions/payever.js